export enum UnitDistance {
    FEET = 'FEET',
    KILOMETERS = 'KILOMETERS',
    METERS = 'METERS',
    MILES = 'MILES'
}

export interface IOpeningAttributes {
    isOpen: boolean;
    changes: string;
    time: string;
}

export interface IStore {
    id: string;
    store_url?: string;
    showStoreDetails: boolean;
    address: IAddress;
    geographical: IStoresGeographical;
    name: string;
    opening?: IOpening[];
    phone_number: IPhoneNumber[];
    tags?: {
        first?: ITag;
        items: ITag[];
        total: number;
    };
    counter_id: string;
    promotions?: string;
    opening_attributes?: IOpeningAttributes;
    productIsAvailable?: boolean; // used for BOPIS
    services?: IInStoreServiceAPI[];
    upcomingEventsNumber: number;
    events?: IEvent[];
    jdaStoreNumber: string;
    in_store_pickup?: boolean;
    holidays?: IHoliday[];
}

export interface IHoliday {
    name: string;
    date: string;
    dayOfWeek?: number;
    openingTime: string;
    closingTime: string;
    hoursMessage?: string;
    isOpen: boolean;
}

export interface IStoresDirectoryItem {
    id: string;
    name: string;
    address: IAddress;
    store_url: string;
}

export interface IAddress {
    city: string;
    country: string;
    country_code: string;
    county?: string;
    description: string;
    neighbourhood: string;
    postal_code: string;
    state: string;
}

export interface IESGeoPoint {
    lat: number;
    lon: number;
}

export interface IOpening {
    day_of_week: number;
    label: string;
    open_hours: {
        close: string;
        open: string;
    }[];
}

export interface IOpeningRaw {
    [key: string]: {
        close: string;
        open: string;
    };
}

export interface IPhoneNumber {
    label: string;
    position: number;
    value: string;
}

export interface ITag {
    label: string;
    type: string;
}

export interface IStoresGeographical {
    coordinates: IESGeoPoint;
    distance: number;
    unit: UnitDistance;
}

export interface IStoresNearPointRequest {
    coordinates: IESGeoPoint;
    size: number;
    unit: UnitDistance;
    distance: number;
}

export interface IStoresNearPointResult {
    storesNearPoint: {
        first: IStore;
        items: IStore[];
        total: number;
    };
}

export interface ICountryResult {
    iso_code: string;
    country: string;
}

export interface IStoresDirectoryResult {
    storesDirectory: IStoresDirectory;
}

export interface IStoresDirectory {
    total: number;
    items: IStoresDirectoryItem[];
    showState: boolean;
}

export interface IStoresByIdsRequest {
    ids: string[];
    coordinates?: IESGeoPoint;
    unit?: UnitDistance;
}

export interface IStoresByIdsResult {
    storesByMultipleIds: {
        first: IStore;
        items: IStore[];
        total: number;
    };
}

export interface IStoreByIdResult {
    store: IStore;
}

export interface IGeoDistanceStoreDetailsRequest {
    id: string;
    coordinates?: IESGeoPoint;
    unit?: UnitDistance;
}

// store inventory payloads
export interface IPayloadStoreInventoryRequest {
    skuId: string;
    radius: number;
    geolocation: {
        lat: number;
        lng: number;
    };
}

export interface IDoor {
    DOOR_ID: number;
    DOORNAME: string;
    STORE_HOURS: string;
    STORE_TYPE: string;
    ADDRESS: string;
    ADDRESS2: string;
    STATE_OR_PROVINCE: string;
    CITY: string;
    COUNTRY: string;
    PHONE1: string;
    LONGITUDE: string;
    LATITUDE: string;
    DISTANCE: string;
}

export interface IStoreInventory {
    is_call: number;
    is_available: number;
    is_unavailable: number;
    available_qty: number;
}

export interface IDoorInventory {
    store_code: number;
    skus_onhand: {
        [skuiId: string]: IStoreInventory;
    };
}

export interface IDoorInventoryMap {
    [doorId: string]: IDoorInventory;
}

export interface IInStoreServiceAPI {
    name: string;
    price: string;
    totalDuration: string;
    totalDurationWithPadding: number;
    id: string;
    onlineContentId: string;
    virtual: string;
    category: IInStoreServiceCategoryAPI;
}

export interface IInStoreServiceCategoryAPI {
    id: string;
    name: string;
    parentId: string;
}

export interface IActiveFilters {
    [filterType: string]: string[] | boolean;
}

export interface IProductDataResults {
    [index: number]: IProductData;
}

export interface IProductData {
    productId: string;
    skus: ISku[];
}

export interface ISku {
    skuId: string;
    productId: string;
}

export interface ISkuData {
    [skuId: string]: ISku;
}

export interface IEvent {
    eventName: string;
    eventDate: string;
    eventTime: string;
    eventType: string;
    eventRsvpPhone: string;
    presenter1: string;
    presenter2: string;
    presenterImage: string;
    description: string;
    price: string;
    startDate: string;
    endDate: string;
    upcomingEvent: boolean;
}
